import React from "react"
import { Box, Flex, Text } from "@chakra-ui/react"
import Icon from "components/elements/Icon"

type Props = {
    icon: string
    label: string
    description?: string
    hasRightLinkIcon?: boolean
    hasChevron?: boolean
  }

const MenuLink = ({
  icon, label, description, hasRightLinkIcon, hasChevron,
}: Props) => (
  <Flex
    px={5}
    py={1.5}
    minH={14}
    alignItems="center"
    justifyContent="space-between"
    _hover={{ backgroundColor: "gray.50" }}
  >
    <Flex minW={0} align="center">
      <Icon size={6} icon={icon} mr={2.5} flexShrink={0} />
      <Box minW={0}>
        <Text noOfLines={description ? 1 : undefined}>{label}</Text>
        {description && <Text fontSize="sm" color="gray.600" noOfLines={1}>{description}</Text>}
      </Box>
    </Flex>
    {hasRightLinkIcon && <Icon size={4.5} icon="link" />}
    {hasChevron && <Icon size={3} icon="next-arrow" flexShrink={0} />}
  </Flex>
)

export default MenuLink
